import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';
import { Box, IconButton } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

const CustomPaginationActions = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
}: TablePaginationActionsProps) => {
    const maxPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
         

            <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0}>
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= maxPage}>
                <KeyboardArrowRight />
            </IconButton>
           
        </Box>
    );
};

export { CustomPaginationActions }